import { apiUrl }  from "../constants";
var axios = require('axios');
var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':localStorage.getItem('token'),'Content-Type':'application/json'}
})
export default class CaptainsApi {
    static getAll() {
        return request.get('/captains');
    }

    static get(id) {
        return request.get(`/captains/${id}`);
    }

    static create(data) {
        return request.post('/captains',{data: data });
    }

    static edit(data, id){
        return request.put(`/captains/${id}`, {data: data});
    }

    static delete(id){
        return request.delete(`captains?id=${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/api/Captains.js